import React from 'react';
import { CHIPOTLE_CONTENT_LOOK } from '@loomstateorg/shared-frontend/components/commercetools-ui/organisms/content-look';
import TilesGroup, { Props as TilesGroupProps } from '@loomstateorg/shared-frontend/components/commercetools-ui/organisms/content/tiles-group';

export interface Props {
  data: TilesGroupProps;
}

const TilesGroupTastic: React.FC<Props> = ({ data }) => {
  return <TilesGroup {...data} backgroundClassName={CHIPOTLE_CONTENT_LOOK.tilesGroupBgClassName} />;
};

export default TilesGroupTastic;
